import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: '',
        userInfo: {}, //用户信息
        devTypeList: [], //指令权限管理
        noDisturbList: {}, //免打扰内容
        checkdata: null, //选中
        clockOption: '',
        changeImei: '',
        currentDate: '',
    },
    mutations: {
        set_token(state, payload) {
            state.token = payload;
            sessionStorage.setItem('token', payload);
        },
        set_userinfo(state, payload) {
            state.userInfo = payload;
            localStorage.setItem('userInfo', payload);
        },
        set_devTypeList(state, payload) {
            state.devTypeList = payload;
            localStorage.setItem('devTypeList', payload);
        },
        set_noDisturbList(state, payload) {
            state.noDisturbList = payload;
            localStorage.setItem('noDisturbList', payload);
        },
        set_checkdata(state, payload) {
            state.checkdata = payload;
            localStorage.setItem('checkdata', payload);
        },
        set_clockOption(state, payload) {
            state.clockOption = payload;
            localStorage.setItem('clockOption', payload);
        },
        set_changeImei(state, payload) {
            state.changeImei = payload;
            localStorage.setItem('changeImei', payload);
        },
        set_currentDate(state, payload) {
            state.currentDate = payload;
            localStorage.setItem('currentDate', payload);
        },
    },
    actions: {

    }
})